import type { SkeletonVariant } from 'shared/ui/skeleton';
import { Skeleton } from 'shared/ui/skeleton';
import * as m from '@paraglide/messages';
export const InstanceSkeleton = ({
  variant
}: SkeletonVariant) => {
  return <div data-sentry-component="InstanceSkeleton" data-sentry-source-file="instance-skeleton.tsx">
      <p className="text-center text-caption font-medium">
        {m.project_ctrl_btns_replicas()}
      </p>
      <div className="relative flex flex-col items-center space-y-2">
        <div className="flex items-center gap-1 rounded-lg">
          <Skeleton className="size-8" variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-skeleton.tsx" />
          <div className="flex flex-row items-end gap-1">
            <Skeleton className="size-5" variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-skeleton.tsx" />
            <p>/</p>
            <Skeleton className="size-5" variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-skeleton.tsx" />
          </div>
          <Skeleton className="size-8" variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="instance-skeleton.tsx" />
        </div>
      </div>
    </div>;
};